/* eslint-disable no-unused-vars */
import React from "react";
import { Row, Col, Form, Input, Button } from "antd";
import { ReactComponent as DeleteIcon } from "../../../../assests/images/deleteIcon.svg";

import {
  checkNumbervalue,
  checkSpecialCharacter,
  validateNumberMinValue,
  isValidDocumentNum,
} from "../../../../utils";

const ChildDocumentRow = ({
  childData,
  deleteItem,
  setChildAwbError,
  handleOnEnter,
  multipleChildStatus,
  childDrawerform,

  handleMultipleAPI,
  setMultipleChildStatus,
  // checkNumbervalue,
}) => {
  const debounce = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), delay);
    };
  };

  const handleDebouncedChange = debounce((e, idx) => {
    if (e?.target?.value?.length <= 10) {
      setMultipleChildStatus({
        status: "error",
        id: `childDocumentNumber${idx}`,
        msg: "Invalid doc no.",
      });
    } else {
      handleMultipleAPI(e);
    }
  }, 900);

  const volumCalculation = (idx = 3) => {
    // Get all form values
    const formValues = childDrawerform.getFieldsValue();

    // Dynamically access the indexed fields
    const length = formValues[`length${idx}`];
    const width = formValues[`width${idx}`];
    const height = formValues[`height${idx}`];

    // Calculate the volumetric weight if all dimensions are provided
    if (length && width && height) {
      const volume = ((+length * +width * +height) / 5000)?.toFixed(2);
      childDrawerform.setFieldsValue({
        [`volumetricWeight${idx}`]: volume || "0.00",
      });
    } else {
      // Set volumetric weight to 0.00 if any dimension is missing
      childDrawerform.setFieldsValue({
        [`volumetricWeight${idx}`]: "0.00",
      });
    }
  };

  return (
    <Row
      style={{
        display: "flex",
        justifyContent: "space-around",
        marginTop: "12px",
      }}
    >
      <div>
        {childData.map((items, idx) => (
          <Col
            key={idx}
            className="d-flex"
            style={{ alignItems: "center", marginBottom: "8px" }}
          >
            <Form.Item
              style={{ width: "22%" }}
              className=""
              validateStatus={
                multipleChildStatus?.id == `childDocumentNumber${idx}`
                  ? multipleChildStatus?.status
                  : null
              }
              help={
                multipleChildStatus?.id == `childDocumentNumber${idx}`
                  ? multipleChildStatus?.msg
                  : null
              }
              // help={multipleChildStatus?.msg}
              label={"Child doc number"}
              name={`childDocumentNumber${idx}`}
              rules={[
                {
                  required: true,
                  message: null,
                },
              ]}
            >
              <Input
                placeholder="Enter doc number"
                id={`childDocumentNumber${idx}`}
                maxLength={11}
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    handleOnEnter(event);
                  } else if (checkNumbervalue(event)) {
                    event.preventDefault();
                  }
                }}
                onChange={(e) => handleDebouncedChange(e, idx)}
              />
            </Form.Item>

            <Form.Item
              label={"Weight(Kg)"}
              name={`weight${idx}`}
              style={{ width: "14%" }}
              rules={[
                {
                  required: true,
                  maxLength: 3,
                  message: "Enter weight",
                },
                () => ({
                  validator(_, data) {
                    let value = data?.toString();
                    if (!value) {
                      return Promise.reject();
                    }

                    if (parseInt(value?.toString()?.substring(1, 0)) === 0) {
                      return Promise.reject("Min weight: 1 kg");
                    }

                    if (value && value?.split(".")?.length > 2) {
                      return Promise.reject("Only one decimal allowed");
                    }

                    if (value > 499.99) {
                      return Promise.reject("Max weight: 499 kg");
                    }
                    return Promise.resolve();
                  },
                  //validateTrigger: "onSubmit",
                }),
              ]}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  handleOnEnter(event);
                } else if (checkNumbervalue(event)) {
                  event.preventDefault();
                }
              }}
            >
              <Input
                placeholder="Enter weight"
                maxLength={6}
                onChange={() => volumCalculation(idx)}
              />
            </Form.Item>

            <Form.Item
              label={
                <span className="calculater-container-pikpin"> Length(Cm)</span>
              }
              style={{ width: "14%" }}
              name={`length${idx}`}
              className=""
              rules={[
                {
                  required: false,
                  message: "Enter length",
                },
                // validateNumberMinValue("cannot be 0")(),
              ]}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  handleOnEnter(event);
                } else if (checkNumbervalue(event) || event.key === ".") {
                  event.preventDefault();
                }
              }}
            >
              <Input
                placeholder="Enter length"
                maxLength={3}
                onChange={() => volumCalculation(idx)}
              />
            </Form.Item>

            <Form.Item
              label="Width(Cm)"
              style={{ width: "14%" }}
              className=""
              name={`width${idx}`}
              rules={[
                {
                  required: false,
                  message: "Enter width",
                },
                // validateNumberMinValue("cannot be 0")(),
              ]}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  handleOnEnter(event);
                } else if (checkNumbervalue(event) || event.key === ".") {
                  event.preventDefault();
                }
              }}
            >
              <Input
                placeholder="Enter width"
                maxLength={3}
                onChange={() => volumCalculation(idx)}
                min={"0"}
              />
            </Form.Item>

            <Form.Item
              className=""
              style={{ width: "14%" }}
              label={
                <span className="calculater-container-pikpin">Height (Cm)</span>
              }
              //   name="height"
              name={`height${idx}`}
              rules={[
                {
                  required: false,
                  message: "Enter height",
                },
                // validateNumberMinValue("cannot be 0")(),
              ]}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  handleOnEnter(event);
                } else if (checkNumbervalue(event) || event.key === ".") {
                  event.preventDefault();
                }
              }}
            >
              <Input
                className=""
                placeholder="Enter height"
                maxLength={3}
                onChange={() => volumCalculation(idx)}
              />
            </Form.Item>

            <Form.Item
              style={{ width: "15%" }}
              label="Vol weight (Kg)"
              name={`volumetricWeight${idx}`}
              // height
              className=""
            >
              <Input
                className=""
                placeholder="Enter Volumetric"
                readOnly={true}
                disabled
                type="number"
              />
            </Form.Item>
            <div style={{ alignSelf: "end", marginBottom: "2px" }}>
              <Button
                onClick={() => deleteItem(idx)}
                style={{ border: "none", padding: "0" }}
              >
                <DeleteIcon />
              </Button>
            </div>
          </Col>
        ))}
      </div>
    </Row>
  );
};

export default ChildDocumentRow;
